
import { isSp } from '@/js/_common';

const main = () => {
    if (document.querySelector('.c-parts-magazine-search-filter') == null) return;

    const parent = document.querySelector('.c-parts-magazine-search-filter');

    // 詳細検索の開く動作
    const detailOpenEl = parent.querySelector('.js-detail-open');
    if (detailOpenEl) {
        detailOpenEl.addEventListener('click', (e) => {
            e.preventDefault();
            parent.querySelector('.c-search-detail').dataset.open = true;
        });
    }

    // 詳細検索の閉じる動作
    parent.querySelector('.js-detail-close').addEventListener('click', (e) => {
        e.preventDefault();
        parent.querySelector('.c-search-detail').dataset.open = false;
    });

    // キーワード入力フォーカス時の動作
    parent.querySelector('.js-keyword-input').addEventListener('focus', (e) => {
        if (!isSp()) return;
        parent.querySelector('.js-keyword-input-sp').dataset.open = true;
        parent.querySelector('.js-keyword-input-sp input').value = parent.querySelector('.js-keyword-input').value;
        parent.querySelector('.js-keyword-input-sp input').focus();
    });

    // spでのキーワード入力終了
    parent.querySelector('.js-keyword-input-sp-close').addEventListener('click', (e) => {
        parent.querySelector('.js-keyword-input').focus();
        parent.querySelector('.js-keyword-input-sp').dataset.open = false;
    });

    // spでのキーワード文字入力時
    parent.querySelector('.js-keyword-input-sp input').addEventListener('input', (e) => {
        parent.querySelector('.js-keyword-input-sp-submit .text').textContent = e.target.value;
        parent.querySelector('.js-keyword-input').value = e.target.value;
        if (e.target.value.length > 0) {
            parent.querySelector('.js-keyword-input-sp-submit').dataset.active = true;
        } else {
            parent.querySelector('.js-keyword-input-sp-submit').dataset.active = false;
        }
    });

    // spでのキーワード入力確定
    parent.querySelector('.js-keyword-input-sp-submit').addEventListener('click', (e) => {
        parent.querySelector('form').submit();
    });

    // スクロール時の検索バー固定動作
    const col2Side = document.querySelector('.c-layouts-col2__side');
    if (col2Side) {
        // fixed化時にフィルターの高さ分のスペースを維持するプレースホルダー
        const placeholder = document.createElement('div');
        placeholder.style.display = 'none';
        parent.after(placeholder);

        // fixedの切り替えでレイアウトが変化しない sentinel 要素を監視対象にする
        const sentinel = document.createElement('div');
        sentinel.classList.add('c-parts-magazine-search-filter-sentinel');
        col2Side.parentNode.insertBefore(sentinel, col2Side);

        const scrollIo = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                parent.dataset.fixedSp = false;
                placeholder.style.display = 'none';
            } else {
                placeholder.style.height = parent.offsetHeight + 'px';
                placeholder.style.display = 'block';
                parent.dataset.fixedSp = true;
            }
        }, {
            rootMargin: '-66px 0px',
            threshold: 0,
        });
        scrollIo.observe(sentinel);
    }
}

export default main;
